import { Injectable } from "@angular/core";

import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Quote, CacheService, ICelebratedSentenceBO } from '@mapfre-tech/amap3';
import * as _ from 'lodash';
import { map, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";

@Injectable({
   providedIn: "root"
})
export class QuoteDayService {

   className = 'QuoteDayService';

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllQuotes(): Observable<ICelebratedSentenceBO[]> {
      return this.http.get<ICelebratedSentenceBO[]>(environment.base_URL + "/celebrated-sentence");
   }

   newQuote(newQuote: ICelebratedSentenceBO) {
      return this.http.post(environment.base_URL + "/celebrated-sentence", newQuote)
   }

   updateQuote(editedQuote: ICelebratedSentenceBO, id: number) {
      return this.http.put(environment.base_URL + `/celebrated-sentence/${id}`, editedQuote)
   }

   deleteQuote(sentenceId: number) {
      return this.http.delete(environment.base_URL + `/celebrated-sentence/${sentenceId}`)
   }

   getRandomQuote(cache = true, cacheKey = "quoteRandom"): Observable<ICelebratedSentenceBO> {
      const params: any = {
         dailySentence: true
      }
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<ICelebratedSentenceBO>;
       } else {
         const observable = this.http.get<ICelebratedSentenceBO>(environment.base_URL_GAIA + "/celebrated_sentences", { params }).pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

}
